import { makeRequest } from "../http-common";

const ReminderDataService = {

    getAll() {
        return makeRequest("get", "/reminder/list");
    },

    create(data) {
        return makeRequest("post", "/reminder", data);
    },

    update(id, data) {
        return makeRequest("put", `/reminder/${id}`, data);
    },

    delete(id) {
        return makeRequest("delete", `/reminder/${id}`);
    },
    
    dismiss(id) {
        return makeRequest("post", `/reminder/${id}/dismiss`);
    }
};

export default ReminderDataService;